var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSlideArrowRight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    rx: 26,
    fill: "#11C2ED",
    fillOpacity: 0.8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8457 37.0986C21.5176 36.7704 21.3333 36.3254 21.3333 35.8614C21.3333 35.3973 21.5176 34.9523 21.8457 34.6241L30.5082 25.9616L21.8457 17.2991C21.5269 16.9691 21.3505 16.527 21.3545 16.0682C21.3585 15.6093 21.5425 15.1704 21.867 14.8459C22.1915 14.5215 22.6304 14.3374 23.0892 14.3334C23.5481 14.3295 23.9901 14.5058 24.3202 14.8246L34.2199 24.7244C34.548 25.0525 34.7323 25.4976 34.7323 25.9616C34.7323 26.4257 34.548 26.8707 34.2199 27.1989L24.3202 37.0986C23.992 37.4267 23.547 37.611 23.0829 37.611C22.6189 37.611 22.1739 37.4267 21.8457 37.0986Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlideArrowRight);
export default __webpack_public_path__ + "static/media/slide-arrow-right.4a88dbe8118dfc2b6c904d8fc90b542d.svg";
export { ForwardRef as ReactComponent };